import { TipoAtendimentoPainelChamadaEnum } from 'view/atendimentos/list/actions/chamar/model-painelChamada'

export enum StatusPareamentoDispositivoPainelEnum {
  AGUARDANDO = 'AGUARDANDO',
  PAREADO = 'PAREADO',
  INVALIDO = 'INVALIDO',
}

export interface GerarPinPareamentoResponse {
  pinUsuario: string
  uuidDispositivo: string
}

export interface VerificarStatusPareamentoResponse {
  status: StatusPareamentoDispositivoPainelEnum
  tokenAcesso?: string
}

export interface DispositivoPainelStatusResponse {
  nomeUnidadeSaude: string
}

export interface DispositivoPainelLoginRequest {
  tokenAcesso: string
  uuidDispositivo: string
}

export interface Chamada {
  id: ID
  nome: string
  sala: string
  tipoAtendimento: TipoAtendimentoPainelChamadaEnum
}

export interface CadastrarSalaPainelChamadasModel {
  nome: string
}

export interface SalaPainelChamadaRow {
  id: ID
  nome: string
}

export interface CadastrarDispositivoPainelChamadasModel {
  nome: string
  codigo: string
}

export interface DispositivoPainelChamadaRow {
  id: ID
  dataPareamento: Instant
  nome: string
}

export interface CredenciaisChamadaPainel {
  tokenAcesso: string
  uuidDispositivo: string
}

export interface PermissaoPainelChamadas {
  enabled: boolean
  hint: string | null
}
